import _ from "lodash";

interface Address {
  street?: string
  streetNumber?: string
  postalCode?: string
  city?: string
  province?: string
  region?: string
  country?: string
}

enum UserRoleEnum {
  PRIVATE,
  COMPANY,
  CONDOMINIUM_ADMIN,
  MUNICIPAL_USER
}

interface ISignUpReqUser {
  name?: string
  surname?: string
  password?: string
  role?: UserRoleEnum
  email?: string
  contactEmail?: string
  mobilePhoneNumber?: string
  landlinePhoneNumber?: string
  fax?: string
  fiscalCode?: string
  pec?: string
  agreementProfiling?: boolean
  agreementMarketing?: boolean
  businessName?: string
  legalAddress?: Address,
  headOfficeAddress?: Address
}

const excludes = [
  'legalAddress_street',
  'legalAddress_streetNumber',
  'legalAddress_postalCode',
  'legalAddress_city',
  'legalAddress_province',
  'headOfficeAddress_street',
  'headOfficeAddress_streetNumber',
  'legalAddress_postalCode',
  'legalAddress_city',
  'headOfficeAddress_province',
  'headOfficeAddress_city',
  'headOfficeAddress_postalCode',
  'confirmPassword',
  'confirmEmail',
  'sameAsRegistrationEmail'
];

export class User {
  static userPublic(values: any, changed: boolean): ISignUpReqUser {
    const obj = _.omit(values, excludes);
    return changed ? obj : _.pickBy(obj, _.identity)
  }

  static userCompany(values: any, changed: boolean): ISignUpReqUser {
    const obj = {
      ..._.omit(values, excludes),
      mobilePhoneNumber: String(values.mobilePhoneNumber) === 'undefined' ? undefined : String(values.mobilePhoneNumber),
      landlinePhoneNumber: String(values.landlinePhoneNumber) === 'undefined' ? undefined : String(values.landlinePhoneNumber),
    };
    return changed ? obj : _.pickBy(obj, _.identity);
  }

  static address(values: any) {
    return _.pickBy(values, _.identity);
  }

  static userBuildingAdmin(values: any, change: boolean): ISignUpReqUser {
    const obj = {
      ..._.omit(values, excludes),
      mobilePhoneNumber: String(values.mobilePhoneNumber) === 'undefined' ? undefined : String(values.mobilePhoneNumber),
      landlinePhoneNumber: String(values.landlinePhoneNumber) === 'undefined' ? undefined : String(values.landlinePhoneNumber),
      fax: String(values.fax) === 'undefined' ? undefined : String(values.fax),
      legalAddress: this.address({
        street: values.legalAddress_street,
        streetNumber: String(values.legalAddress_streetNumber) === 'undefined' ? undefined : String(values.legalAddress_streetNumber),
        postalCode: String(values.legalAddress_postalCode) === 'undefined' ? undefined : String(values.legalAddress_postalCode),
        city: values.legalAddress_city,
        province: values.legalAddress_province,
      }),
      headOfficeAddress: this.address({
        street: values.headOfficeAddress_street,
        streetNumber: String(values.headOfficeAddress_streetNumber) === 'undefined' ? undefined : String(values.headOfficeAddress_streetNumber),
        postalCode: String(values.headOfficeAddress_postalCode) === 'undefined' ? undefined : String(values.headOfficeAddress_postalCode),
        city: values.headOfficeAddress_city,
        province: values.headOfficeAddress_province,
      })
    };
    return change ? obj : _.pickBy(obj, _.identity);
  }

  static userMunicipal(values: any, change: boolean): ISignUpReqUser {
    const obj = {
      ..._.omit(values, excludes),
      mobilePhoneNumber: String(values.mobilePhoneNumber) === 'undefined' ? undefined : String(values.mobilePhoneNumber),
      landlinePhoneNumber: String(values.landlinePhoneNumber) === 'undefined' ? undefined : String(values.landlinePhoneNumber),
      fax: String(values.fax) === 'undefined' ? undefined : String(values.fax),
      legalAddress: this.address({
        street: values.legalAddress_street,
        streetNumber: String(values.legalAddress_streetNumber) === 'undefined' ? undefined : String(values.legalAddress_streetNumber),
        postalCode: String(values.legalAddress_postalCode) === 'undefined' ? undefined : String(values.legalAddress_postalCode),
        city: values.legalAddress_city,
        province: values.legalAddress_province,
      })
    }
    return change ? obj : _.pickBy(obj, _.identity);
  }
}
